/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type PinCommentConfig_formValues = {
    readonly enableQaFlag: boolean;
    readonly qaFlagEnabledSites: ReadonlyArray<string>;
    readonly " $refType": "PinCommentConfig_formValues";
};
export type PinCommentConfig_formValues$data = PinCommentConfig_formValues;
export type PinCommentConfig_formValues$key = {
    readonly " $data"?: PinCommentConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"PinCommentConfig_formValues">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PinCommentConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "enableQaFlag",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "qaFlagEnabledSites",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = 'e2fa08300754c4d5a91dcd6dc073a07e';
export default node;
